(function (freyaView, $) {
  var freyaSection;
  var freyaSectionHeight;
  var freyaSectionOffsetTop;

  var videoElement;

  var downloadTodayElement;
  var freyaiPhone1Element;

  var showNextSlideTimeout;
  var currentSlideIndex = 0;
  var screenshotImageElements = [];
  var slideDescriptionElement;
  var isSlideshowRunning = false;

  var slides = [
    { image: "freya-iphone-1", htmlText: "Introducing <strong>Freya</strong>, your virtual birth partner." },
    {
      image: "freya-iphone-2",
      htmlText: "<strong>Freya</strong> will help you to relax with calming visualisations and guided meditation.",
    },
    {
      image: "freya-iphone-3",
      htmlText: "Use our <strong>surge timer</strong> to keep track of how your labour is progressing.",
    },
  ];

  freyaView.init = function () {
    downloadTodayElement = $(".freya-download-today");
    freyaiPhone1Element = $(".freya-iphone-1");

    $(".freya-iphone").each(function (index, el) {
      screenshotImageElements.push($(el));
    });

    freyaSection = $("#freya-section");
    slideDescriptionElement = $(".freya-description-inner");

    var attributeExtension = el.window.width() < 768 ? "mobile" : "desktop";
    videoElement = $(".freya-bg-video");
    el.Utils.setVideoSrc(
      videoElement,
      videoElement.data("src-" + attributeExtension),
      videoElement.data("width-" + attributeExtension),
      videoElement.data("height-" + attributeExtension),
    );

    calculateGeometry();
    setTimeout(calculateGeometry, 2000);
    setTimeout(calculateGeometry, 6000);
    setInterval(calculateGeometry, 18000);

    el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
      var sectionOffset = windowScrollTop - freyaSectionOffsetTop + el.windowHeight;

      if (sectionOffset < 0 || sectionOffset > freyaSectionHeight * 2) {
        isSlideshowRunning = false;
        return;
      }

      if (!isSlideshowRunning) {
        isSlideshowRunning = true;
        showNextSlide();
      }
    });

    wireEvents();
  };

  function wireEvents() {
    el.documentElement.on("WINDOW_RESIZED_EVENT", function () {
      calculateGeometry();
      setTimeout(calculateGeometry, 2000);
    });
  }

  function showNextSlide() {
    if (showNextSlideTimeout) {
      clearTimeout(showNextSlideTimeout);
    }

    showNextSlideTimeout = setTimeout(showNextSlide, 7000);

    if (!isSlideshowRunning) {
      return;
    }

    var nextSlide = slides[currentSlideIndex.mod(slides.length)];

    var nextImageUrl = "/img/" + nextSlide.image + ".png";

    el.Utils.preloadImage(nextImageUrl, function () {
      slideDescriptionElement.transit({ opacity: 0 }, 400, "ease-out");
      setTimeout(function () {
        slideDescriptionElement.html(nextSlide.htmlText);

        var nextElement = screenshotImageElements[currentSlideIndex.mod(2)];
        nextElement.attr("src", nextImageUrl).transit({ opacity: 1 }, 700, "linear");
        var prevElement = screenshotImageElements[(currentSlideIndex + 1).mod(2)];
        prevElement.transit({ opacity: 0, delay: 200 }, 600, "linear");

        slideDescriptionElement.transit({ opacity: 1, delay: 1000 }, 1200, "ease-out");
      }, 600);
    });

    currentSlideIndex++;
  }

  function calculateGeometry() {
    freyaSectionHeight = freyaSection.height();
    freyaSectionOffsetTop = freyaSection.offset().top;

    var downloadTodayCssRight = el.windowWidth >= 1240 ? freyaiPhone1Element.width() : "45%";
    downloadTodayElement.css("right", downloadTodayCssRight);

    if (el.window.width() < 768) {
      videoElement.addClass("freya-stretch-video");
    } else {
      videoElement.removeClass("freya-stretch-video");
    }
  }
})((window.el.FreyaView = window.el.FreyaView || {}), jQuery);
